import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { CollaboratorApi } from '../../../apis/CollaboratorApi/CollaboratorApi.ts';
import { Collaborator, ICollaborator, ICollaboratorPayload } from '../Collaborator.ts';

export function usePostCollaboratorMutations() {
    const queryClient = useQueryClient();

    return useMutation<ICollaborator, AppMedError, ICollaboratorPayload>({
        mutationKey: [QueryKeys.collaborator, QueryKeys.collaborators],
        mutationFn: async (variables: ICollaboratorPayload) => {
            const id = await CollaboratorApi.postCollaborator(variables);
            const collaborator = new Collaborator({ ...(variables as ICollaborator), id: Number(id) });
            return collaborator;
        },
        onSuccess: async (data: ICollaborator) => {
            const collaboratorData: ICollaborator = { ...data };

            queryClient.setQueryData<ICollaborator>([QueryKeys.collaborator, data.id], collaboratorData);

            queryClient.setQueryData<ICollaborator[]>([QueryKeys.collaborators], (prev) => {
                return prev ? [...prev, collaboratorData] : [collaboratorData];
            });
        },
    });
}
